var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnswer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1968 35.7394C34.5768 35.715 34.9041 35.4627 35.0245 35.1014L35.6963 33.0862C35.8084 32.7499 35.7208 32.3792 35.4702 32.1285L33.7581 30.4164C33.4521 30.1104 32.9762 30.0541 32.6073 30.2803L31.0207 31.2527C29.9138 31.9311 28.4862 31.7622 27.5683 30.8442L25.1552 28.4311C24.2372 27.5132 24.0683 26.0856 24.7467 24.9787L25.7191 23.3921C25.9453 23.0232 25.889 22.5473 25.583 22.2413L23.8709 20.5292C23.6202 20.2786 23.2495 20.1911 22.9132 20.3031L20.898 20.9749C20.5367 21.0953 20.2844 21.4226 20.26 21.8026C20.1414 23.6433 21.9294 26.5288 25.7 30.2994C29.4706 34.07 32.3561 35.858 34.1968 35.7394ZM34.3171 37.6073C31.7653 37.7717 28.505 35.7515 24.3764 31.623C20.2479 27.4944 18.2277 24.2341 18.3921 21.6823C18.4655 20.5423 19.2223 19.5604 20.3061 19.1992L22.3213 18.5275C23.3302 18.1912 24.4425 18.4537 25.1944 19.2057L26.9065 20.9178C27.8245 21.8357 27.9934 23.2634 27.315 24.3702L26.3426 25.9568C26.1164 26.3258 26.1727 26.8016 26.4787 27.1076L28.8918 29.5207C29.1978 29.8267 29.6736 29.883 30.0426 29.6568L31.6292 28.6844C32.736 28.006 34.1637 28.1749 35.0816 29.0929L36.7937 30.805C37.5457 31.5569 37.8082 32.6692 37.4719 33.6781L36.8002 35.6933C36.439 36.7771 35.4571 37.5339 34.3171 37.6073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.0ddff8f0244707f508367b8c93373193.svg";
export { ForwardRef as ReactComponent };